import React from 'react';
import { Image } from 'react-native';
import type { BracketCompetitionProps, BracketProps, CompanyProps, CompetitionResultTypeProps, LeagueProps, PublicPlayerProps } from '../../types';
import { Icons } from '../../Components';
import moment from 'moment-mini';
import { Button, Text, View } from '../../Components/Themed';
import { useColors } from '../../constants/useColors';

type BracketCompetitionCardProps = {
    bracket_competition:BracketCompetitionProps,
    competition_result_type:CompetitionResultTypeProps,
    company?:CompanyProps,
    admin?:PublicPlayerProps,
    pacer?:PublicPlayerProps,
    league?:LeagueProps,
    bracket?:BracketProps,
    onCompetitionSelect:(c:BracketCompetitionProps) => void
}
const BracketCompetitionCard = ({ bracket_competition, bracket, league, company, admin, onCompetitionSelect }:BracketCompetitionCardProps) => {
    const Colors = useColors();
    const cl = bracket_competition.market_type == 'FOR_MONEY' ? '$' : 'E'
    let current_payout = bracket_competition.ticket_revenue
    if(bracket_competition.promo_payout){ current_payout += bracket_competition.promo_payout }
    if(bracket_competition.guaranteed_payout && bracket_competition.guaranteed_payout > current_payout){ current_payout = bracket_competition.guaranteed_payout }

    const tickets_available = bracket_competition.max_brackets - bracket_competition.tickets_sold
    const is_live = moment().isAfter(moment(bracket_competition.scheduled_datetime)) ? true : false
    const is_closed = bracket_competition.status == 'closed' ? true : false
    return (
        <Button float style={{ flex:1, padding:0 }} onPress={() => onCompetitionSelect(bracket_competition)}>
            <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10, borderTopRightRadius:8, borderTopLeftRadius:8 }}>
                <Image
                    source={{ uri: bracket_competition.image?.url ?? 'https://res.cloudinary.com/hoabts6mc/image/upload/v1722453927/default_man_n96ofq.webp' }}
                    style={{ height:45, width:45, borderRadius:4}}
                    resizeMode='cover'
                />
                <View transparent style={{ flex:1, marginLeft:10, marginRight:10  }}>
                    <Text theme='h2'>{bracket_competition.competition_name}</Text>
                    <Text style={{ marginTop:3 }} theme='description'>{bracket_competition.competition_description}</Text>
                </View>
                <Text size={20} color={Colors.text.action} weight='bold'>{cl}{bracket_competition.buy_in}</Text>
            </View>
            <View type='body' style={{ flex:1, padding:10 }}>
                <View type='row'>
                    {bracket && league ?
                    <View style={{ flex:1, flexDirection:'row', alignItems:'center', marginRight:10 }}>
                        <Image
                            source={{ uri: league.league_image }}
                            style={{ height:30, width:30, borderRadius:4 }}
                            resizeMode='cover'
                        />
                        <View style={{ flex:1, marginLeft:10 }}>
                            <Text theme='h2'>{bracket.bracket_name}</Text>
                            <Text theme='description'>Starts at {moment(bracket.scheduled_datetime).format('MMM DD hh:mm a')}</Text>
                        </View>
                    </View>
                    :<></>}
                    {tickets_available > 0 ? 
                    <View style={{ justifyContent:'center', alignItems:'center' }}>
                        <Text size={18} color={Colors.text.h1} weight='bold'>{tickets_available}</Text>
                        <Text style={{ marginTop:3 }} theme='description'>TICKETS</Text>
                    </View>
                    :
                    <View style={{ justifyContent:'center', alignItems:'center' }}>
                        <Text size={18} color={Colors.text.error} weight='bold'>FULL</Text>
                    </View>
                    }
                </View>
            </View>

            <View type='footer' style={{ flexDirection:'row', alignItems:'center', padding:10, borderBottomRightRadius:8, borderBottomLeftRadius:8 }}>
                {company ?
                <Image
                    source={{ uri: company.company_image?.url ?? 'https://res.cloudinary.com/hoabts6mc/image/upload/v1722453927/default_man_n96ofq.webp' }}
                    style={{ height:30, width:30, borderRadius:4}}
                    resizeMode='cover'
                />
                :admin ?
                <Image
                    source={{ uri: admin.profile_pic && admin.profile_pic != '' ? admin.profile_pic : 'https://res.cloudinary.com/hoabts6mc/image/upload/v1722453927/default_man_n96ofq.webp' }}
                    style={{ height:30, width:30, borderRadius:4}}
                    resizeMode='cover'
                />
                :<></>}
                {bracket_competition.prize_override ?
                <View transparent style={{ flex:1, flexDirection:'row', alignItems:'center', marginLeft:10 }}>
                    <View transparent style={{ flex:1, marginRight:10}}>
                        <Text size={12} weight='bold' color={Colors.text.h1}>ADDITIONAL PRIZE</Text>
                        <Text style={{ marginTop:3 }} size={10} color={Colors.text.gold} weight='bold'>{bracket_competition.prize_override}</Text>
                    </View>
                    {bracket_competition.prize_image?.url ?
                    <Image
                        source={{ uri: bracket_competition.prize_image.url }}
                        style={{ height:30, width:30, borderRadius:4}}
                        resizeMode='cover'
                    />
                    :
                    <Icons.AwardRibbonIcon size={24} color={Colors.text.gold} />
                    }
                </View>
                :
                <View transparent style={{ flex:1, flexDirection:'row', alignItems:'center' }}>
                    <View transparent style={{ flex:1, marginLeft:20, marginRight:20 }}>
                        <Text theme='h2'>CURRENT PAYOUT</Text>
                        {is_closed ?
                        <Text style={{ marginTop:3 }} color={Colors.text.gold} weight='bold' size={12}>COMPLETED</Text>
                        :is_live ? 
                        <Text style={{ marginTop:3 }} color={Colors.text.error} weight='bold' size={12}>IN PROGRESS</Text>
                        :
                        <Text style={{ marginTop:3 }} theme='description'>Join Until {moment(bracket_competition.scheduled_datetime).format('ddd hh:mm a')}</Text>
                        }
                    </View>
                    <Text color={Colors.text.success} size={20} weight='bold'>{cl}{current_payout.toFixed(2)}</Text>
                </View>
                }
            </View>
        </Button>
    )
}

export default BracketCompetitionCard